module.exports = __webpack_public_path__ + "img/brainfuck.7e26e6c9.png";